import { apiCall, API_CONFIG, buildApiUrl, buildWhatsappCrmApiUrl } from './api';
import { authAPI } from './auth-api';

export const whatsappAPI = {
  // Create WhatsApp que
  createQue: async (queData) => {
    try {
      const formData = new FormData();

      formData.append('templateName', queData.templateName);
      formData.append('headerType', queData.headerType);

      if (queData.headerText) {
        formData.append('headerText', queData.headerText);
      }

      if (queData.headerImage instanceof File) {
        formData.append('headerImage', queData.headerImage);
      }

      formData.append('userData', JSON.stringify(queData.userData));
      formData.append('variables', JSON.stringify(queData.variables));
      formData.append('buttons', JSON.stringify(queData.buttons));

      return await apiCall(API_CONFIG.ENDPOINTS.WHATSAPP_QUE_CREATE, {
        method: 'POST',
        body: formData
      });
    } catch (error) {
      console.error('Error creating WhatsApp que:', error);
      throw error;
    }
  },

  // Fetch all WhatsApp ques
  fetchAllQues: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();

      if (params.type) queryParams.append('type', params.type);
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);

      const endpoint = `${API_CONFIG.ENDPOINTS.WHATSAPP_QUE_FETCHALL}?${queryParams.toString()}`;

      const response = await apiCall(endpoint);
      return response;
    } catch (error) {
      console.error('Error fetching WhatsApp Ques:', error);
      throw error;
    }
  },

  fetchQueById: async (queId) => {
    try {
      const endpoint = `${API_CONFIG.ENDPOINTS.WHATSAPP_QUE_FETCHALL}/${queId}`;
      const response = await apiCall(endpoint);
      return response;
    } catch (error) {
      console.error('Error fetching WhatsApp Que:', error);
      throw error;
    }
  },

  // Fetch WhatsApp templates
  fetchTemplates: async (afterCursor = 'none') => {
    try {
      const token = authAPI.getToken();
      const headers = {
        'Content-Type': 'application/json',
      };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      // Use the WhatsApp CRM API URL builder
      const url = buildWhatsappCrmApiUrl(`/whatsapp/templates/${afterCursor}`);
      const response = await fetch(url, {
        method: 'GET',
        headers: headers,
        mode: 'cors', // Explicitly set CORS mode
        credentials: 'omit', // Don't send credentials to avoid CORS issues
      });

      if (!response.ok) {
        if (response.status === 400) {
          const errorData = await response.json();
          if (errorData.message === "No more templates to fetch") {
            return {
              success: true,
              data: {
                templates: [],
                nextCursor: null
              }
            };
          }
        }

        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success && data.message === "No more templates to fetch") {
        return {
          success: true,
          data: {
            templates: [],
            nextCursor: null
          }
        };
      }

      return data;
    } catch (error) {
      console.error('Error fetching WhatsApp templates:', error);
      throw error;
    }
  },

  fetchQueStats: async (queId) => {
    try {
      const endpoint = `${API_CONFIG.ENDPOINTS.WHATSAPP_QUE_STATS}/${queId}`;
      const response = await apiCall(endpoint);
      return response;
    } catch (error) {
      console.error('Error fetching WhatsApp Que stats:', error);
      throw error;
    }
  },

  fetchIncomingChats: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.filter) queryParams.append('filter', params.filter);

      const endpoint = `${API_CONFIG.ENDPOINTS.WHATSAPP_CHATS}?${queryParams.toString()}`;
      return await apiCall(endpoint);
    } catch (error) {
      console.error('Error fetching incoming WhatsApp chats:', error);
      throw error;
    }
  },

  fetchConversations: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.filter) queryParams.append('filter', params.filter);

      const endpoint = `${API_CONFIG.ENDPOINTS.WHATSAPP_CONVERSATIONS}?${queryParams.toString()}`;
      return await apiCall(endpoint);
    } catch (error) {
      console.error('Error fetching WhatsApp conversations:', error);
      throw error;
    }
  },

  fetchThread: async (phone, params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.limit) queryParams.append('limit', params.limit);
      const qs = queryParams.toString();
      const endpoint = `${API_CONFIG.ENDPOINTS.WHATSAPP_CHAT_THREAD}/${encodeURIComponent(phone)}${qs ? `?${qs}` : ''}`;
      return await apiCall(endpoint);
    } catch (error) {
      console.error('Error fetching WhatsApp thread:', error);
      throw error;
    }
  },

  sendChatMessage: async (payload) => {
    try {
      return await apiCall(API_CONFIG.ENDPOINTS.WHATSAPP_CHAT_SEND, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
    } catch (error) {
      console.error('Error sending WhatsApp chat message:', error);
      throw error;
    }
  },

  markConversationRead: async (phone) => {
    try {
      return await apiCall(API_CONFIG.ENDPOINTS.WHATSAPP_CHAT_MARK_READ, {
        method: 'POST',
        body: JSON.stringify({ phone }),
      });
    } catch (error) {
      console.error('Error marking WhatsApp conversation read:', error);
      throw error;
    }
  },

  deleteChat: async (chatId) => {
    try {
      return await apiCall(`${API_CONFIG.ENDPOINTS.WHATSAPP_CHATS}/${chatId}`, {
        method: 'DELETE',
      });
    } catch (error) {
      console.error('Error deleting WhatsApp chat:', error);
      throw error;
    }
  },
};